import type { RRDeviceType } from '@racemap/sdk/schema/trackers';
import { TRACKER_TYPES } from '../../consts/trackers';

export const rrDeviceTypes: Array<RRDeviceType> = [
  TRACKER_TYPES.RRDecoder,
  TRACKER_TYPES.RRTrackbox,
  TRACKER_TYPES.RRUbidium,
];
